// CarbonReportsPanel — carbon estimate reports
import { carbonReports } from "@/mocks/relatorios";

export default function CarbonReportsPanel() {
  return (
    <div className="space-y-4">
      {/* Carbon disclaimer */}
      <div className="bg-amber-50 border border-amber-200 rounded-xl p-4">
        <div className="flex items-start gap-3">
          <div className="w-8 h-8 rounded-lg bg-amber-100 flex items-center justify-center shrink-0">
            <i className="ri-information-line text-amber-600 w-full h-full flex items-center justify-center text-lg" />
          </div>
          <p className="text-xs text-amber-700 leading-relaxed">
            <strong>Estimativas preliminares.</strong> Os valores apresentados são estimativas baseadas em dados dendrométricos e modelos simplificados. Não representam certificação oficial de crédito de carbono.
          </p>
        </div>
      </div>

      <h3 className="text-sm font-semibold text-foreground-900">Relatórios de Carbono</h3>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
        {carbonReports.map((r) => (
          <div key={r.id} className="bg-white rounded-xl border border-background-200/70 p-4 hover:border-teal-200 transition-colors group">
            <div className="flex items-start gap-3 mb-3">
              <div className="w-10 h-10 rounded-xl bg-teal-50 flex items-center justify-center shrink-0">
                <i className="ri-cloud-line text-teal-500 w-full h-full flex items-center justify-center text-lg" />
              </div>
              <div className="flex-1 min-w-0">
                <h4 className="font-semibold text-foreground-900 text-sm">{r.title}</h4>
                <p className="text-xs text-foreground-400 mt-1 line-clamp-2">{r.description}</p>
              </div>
            </div>
            <div className="flex flex-wrap gap-1.5 mb-3">
              {r.indicators.map((ind, i) => (
                <span key={i} className="text-xs bg-teal-50 text-teal-700 px-2 py-0.5 rounded border border-teal-100">{ind}</span>
              ))}
            </div>
            <div className="flex items-center justify-between">
              <span className="text-xs text-foreground-400">Última geração: {r.lastGenerated}</span>
              <button className="px-3 py-1.5 text-xs font-medium text-white bg-teal-600 rounded-lg hover:bg-teal-700 transition-colors whitespace-nowrap opacity-0 group-hover:opacity-100">
                <i className="ri-magic-line w-3.5 h-3.5 inline-flex items-center justify-center mr-1" />
                Gerar
              </button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}